var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { CandidatesOrder } from "@sequentech/ui-core";
import { EditBase, useNotify, useUpdate } from "react-admin";
import { ContestDataForm } from "./EditContestDataForm";
import { serializeIvrEntityAnnotations } from "@/utils/ivr";
export var EditContestData = function () {
    var update = useUpdate()[0];
    var notify = useNotify();
    function updateCandidatesOrder(data) {
        return __awaiter(this, void 0, void 0, function () {
            var contestPresentation, candidates, index, candidate, candidatePresentation;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        contestPresentation = data.presentation;
                        if (!((contestPresentation === null || contestPresentation === void 0 ? void 0 : contestPresentation.candidates_order) === CandidatesOrder.CUSTOM)) return [3 /*break*/, 4];
                        candidates = (_a = data.candidatesOrder) !== null && _a !== void 0 ? _a : [];
                        index = 0;
                        _b.label = 1;
                    case 1:
                        if (!(index < candidates.length)) return [3 /*break*/, 4];
                        candidate = candidates[index];
                        candidatePresentation = candidate.presentation;
                        if (!((candidatePresentation === null || candidatePresentation === void 0 ? void 0 : candidatePresentation.sort_order) !== index)) return [3 /*break*/, 3];
                        return [4 /*yield*/, update("sequent_backend_candidate", {
                                id: candidate.id,
                                data: {
                                    presentation: __assign(__assign({}, candidatePresentation), { sort_order: index }),
                                },
                                previousData: candidate,
                            }, { returnPromise: true })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var transform = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, presentation, i18n, fromPresentationDescription;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateCandidatesOrder(data)];
                case 1:
                    _d.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    notify(error_1 instanceof Error ? error_1.message : String(error_1), { type: "error" });
                    throw error_1;
                case 3:
                    delete data.candidatesOrder;
                    presentation = data === null || data === void 0 ? void 0 : data.presentation;
                    i18n = (_a = presentation === null || presentation === void 0 ? void 0 : presentation.i18n) !== null && _a !== void 0 ? _a : {};
                    fromPresentationDescription = ((_b = i18n === null || i18n === void 0 ? void 0 : i18n.en) === null || _b === void 0 ? void 0 : _b.description) || ((_c = i18n[Object.keys(i18n)[0]]) === null || _c === void 0 ? void 0 : _c.description) || "";
                    data.description = fromPresentationDescription;
                    data.annotations = serializeIvrEntityAnnotations(data.annotations);
                    return [2 /*return*/, data];
            }
        });
    }); };
    return (_jsx(EditBase, { redirect: ".", transform: transform, children: _jsx(ContestDataForm, {}) }));
};
